import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.MatchBankAccountWithXeroPopup', {
    areYouSure: 'Are you sure you want to skip matching?',
    notAllMatchedAreYouSure: 'Not all bank accounts are matched. Are you sure you want to skip matching?',
    confirm: 'Match',
    createNewXeroBankAccount: 'New Xero bank account',
    matchBankAccountWithXero: 'Match bank account to Xero',
    matchEachBankAccount: 'Bank account',
    withXeroAccount: 'Xero account',
    yesSkip: 'Yes, skip',
    matchedSuccessfully: 'Xero bank account matched successfully',
    areYouSureAboutCreatingXeroBA: 'Are you sure you want to create a new Xero bank account?',
    confirmCreatingXeroBA: 'Yes, create',
});
